import { render, staticRenderFns } from "./VideoCallDetailsDialog.vue?vue&type=template&id=56c8cbcb&"
import script from "./VideoCallDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./VideoCallDetailsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports